// icons
import { SiAdobepremierepro, SiUnrealengine, SiRubyonrails } from "react-icons/si";
import { PiNumberEightBold } from "react-icons/pi";
import { FaCode, FaGithub, FaApple, FaReact, FaGitAlt, FaJava, FaSwift } from "react-icons/fa";
import { GiPlatform } from "react-icons/gi";
import { VscVscode } from "react-icons/vsc";
import { ImAndroid } from "react-icons/im";
import { IoLogoFirebase } from "react-icons/io5";
import { AiOutlineDotNet } from "react-icons/ai";
import figma_icon from "../../../assets/icons/figma_icon.svg"
import python_icon from "../../../assets/icons/python_icon.svg"

// styles
import styles from "./css/SkillsSection.module.css";


// technical skills
const technicalSkills = [
    {
        name: "React (+Native)",
        text: "A JS & TS Library",
        icon: <FaReact className={styles.techIcon} style={{ color: "#7AC9EA" }} />,
        bgColour: "#436472",
    },
    {
        name: "Git",
        text: "Version Control",
        icon: <FaGitAlt className={styles.techIcon} style={{ color: "#e0644f" }} />,
        bgColour: "#472c27",
    },
    {
        name: "Firebase",
        text: "Backend & Databse",
        icon: <IoLogoFirebase className={styles.techIcon} style={{ color: "#ffaa33" }} />,
        bgColour: "#a55b0c",
    },
    {
        name: "Java",
        text: "Android and Software Dev",
        icon: <FaJava className={styles.techIcon} style={{ color: "#f05353" }} />,
        bgColour: "#0f597e",
    },
    {
        name: "Swift",
        text: "iOS Dev",
        icon: <FaSwift className={styles.techIcon} style={{ color: "#eee" }} />,
        bgColour: "#a03120",
    },
    {
        name: ".NET (C#)",
        text: "Computer Software Framewok",
        icon: <AiOutlineDotNet className={styles.techIcon} style={{ color: "#fff" }} />,
        bgColour: "#371a9e",
    },
    {
        name: "Ruby on Rails",
        text: "MVC Web Framework",
        icon: <SiRubyonrails className={styles.techIcon} style={{ color: "#ce0808" }} />,
        bgColour: "#343338",
    },
    {
        name: "Python",
        text: "General Purpose Language",
        icon: <img src={python_icon} className={styles.techImg} alt="python_logo" />,
        bgColour: "#343338",
    },
];
// tools and platforms
const tools = [
    {
        name: "GitHub",
        text: "Version Control Platform",
        icon: <FaGithub className={styles.techIcon} style={{ color: "#fff" }} />,
        bgColour: "#343338",
    },
    {
        name: "Figma",
        text: "Design Tool",
        icon: <img src={figma_icon} className={styles.techImg} alt="figma_logo" />,
        bgColour: "#2d4539",
    },
    {
        name: "Premiere Pro",
        text: "Video Editing Tool",
        icon: <SiAdobepremierepro className={styles.techIcon} style={{ color: "#080861" }} />,
        bgColour: "#7878db",
    },
    {
        name: "Visual Studio Code",
        text: "General Purpose IDE",
        icon: <VscVscode className={styles.techIcon} style={{ color: "#35a5f0" }} />,
        bgColour: "#343338",
    },
    {
        name: "Xcode",
        text: "Apple Development IDE",
        icon: <FaApple className={styles.techIcon} style={{ color: "#fff" }} />,
        bgColour: "#343338",
    },
    {
        name: "Android Studio",
        text: "Android Development IDE",
        icon: <ImAndroid className={styles.techIcon} style={{ color: "#40cf85" }} />,
        bgColour: "#2d4539",
    },
    {
        name: "Unreal Engine",
        text: "Game Development Platform",
        icon: <SiUnrealengine className={styles.techIcon} style={{ color: "#fff" }} />,
        bgColour: "#343338",
    },
    {
        name: "8th Wall",
        text: "AR Development Platform",
        icon: <PiNumberEightBold className={styles.techIcon} style={{ color: "#fff" }} />,
        bgColour: "#420a68",
    },
];


export default function SkillsSection() {
    return (
        // background
        <div className={styles.aboutSectionContainer}>
            {/* header, text, cards */}
            <div className={styles.contentContainer}>

                {/* header, text */}
                <div className={styles.textContainer}>
                    <div className={styles.headerText}>
                        My Skills
                        <span className={styles.headerDivider}></span>
                    </div>
                    <div className={styles.aboutText}>
                        I've developed a diverse set of skills across multiple domains, allowing me to create comprehensive solutions from concept to deployment.
                    </div>
                </div>

                {/* cards */}
                <div className={styles.aboutCardsContainer}>

                    {/* technical skills */}
                    <div className={styles.skillsCard}>
                        <div className={styles.cardHeader}>
                            <div className={styles.cardIconContainer}>
                                <FaCode className={styles.cardIcon} />
                            </div>
                            <div className={styles.cardHeaderText}>Technical Skills</div>
                        </div>

                        <div className={styles.skillsContainer}>
                            {technicalSkills.map((skill, index) => (
                                <div key={index} className={styles.skill}>
                                    <div className={styles.skillIconContainer} style={{ backgroundColor: skill.bgColour }}>
                                        {skill.icon}
                                    </div>
                                    <div className={styles.skillTextContainer}>
                                        <div className={styles.skillName}>{skill.name}</div>
                                        <div className={styles.skillText}>{skill.text}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>


                    
                    {/* tools & platforms */}
                    <div className={styles.toolsCard}>
                        <div className={styles.cardHeader}>
                            <div className={styles.cardIconContainer}>
                                <GiPlatform className={styles.cardIcon} />
                            </div>
                            <div className={styles.cardHeaderText}>Tools & Platforms</div>
                        </div>
                    
                        <div className={styles.skillsContainer}>
                            {tools.map((skill, index) => (
                                <div key={index} className={styles.skill}>
                                    <div className={styles.skillIconContainer} style={{ backgroundColor: skill.bgColour }}>
                                        {skill.icon}
                                    </div>
                                    <div className={styles.skillTextContainer}>
                                        <div className={styles.skillName}>{skill.name}</div>
                                        <div className={styles.skillText}>{skill.text}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
